//ANT DESIG IMPORTS
import { Table } from "antd";

const InterestRateChart = (props) => {
  const { interestRateChartList } = props;

  const columns = [
    {
      title: "Period Type",
      dataIndex: "periodType",
    },
    {
      title: "Period From / To",
      dataIndex: "periodFromTo",
    },
    {
      title: "Amount Range",
      dataIndex: "amountRange",
    },
    {
      title: "Interest",
      dataIndex: "interest",
    },
    {
      title: "Description",
      dataIndex: "description",
    },
    // {
    //   title: "Actions",
    //   render: (_, record) => (
    //     <>
    //       <IncentivesModal
    //         transactionObj={record}
    //       />
    //     </>
    //   ),
    // },
  ];
  return <Table columns={columns} dataSource={interestRateChartList} />;
};

export default InterestRateChart;